import React from 'react'

const AppContext = React.createContext()

const AppProvider = props => {
  return (
    <AppContext.Provider value={{ parentChildrens: props.parentChildrens }}>
      {props.children}
    </AppContext.Provider >
  )
}

const AppPage = {
  title: '内容区域',
  category: '母版组件',
  icon: require('../icon/前台页面.svg'),
  component: props => {
    const context = React.useContext(AppContext)
    return context ? <>{context.parentChildrens}</> : null
  }
}

export default AppPage

export {
  AppProvider
}